export const SET_FORM = 'SET_FORM';
export const SET_STEP = 'SET_STEP';
export const SET_TYPE = 'SET_TYPE';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS';
export const RESET = 'RESET';
export const SET_SEARCH_AREA = 'SET_SEARCH_AREA';
